import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login/Login";
import UsersList from "./pages/User/UsersList";
import UserRegistration from "./pages/User/UserRegistration";
import UserUpdate from "./pages/User/UserUpdate";
import UserMonitoring from "./pages/UserMonitoring/UserMonitoring";
import DashboardGeral from "./pages/Home/DashboardGeral";
import UserDashboard from "./pages/UserDashboard/UserDashboard";
import ImageGallery from "./pages/ImageGallery/ImageGallery";
import ComputerUpdate from "./pages/Computadores/ComputadoresAlterar";
import ComputerList from "./pages/Computadores/ComputadoresListar";
import RequireAuth from "./pages/Login/RequireAuth";
import CalendarioList from "./pages/Calendario/CalendarioList";
import CalendarioRegistration from "./pages/Calendario/CalendarioRegistration";
import CalendarioUpdate from "./pages/Calendario/CalendarioUpdate";
import ConfiguracoesGerais from "./pages/General/ConfiguracoesGerais";
import AlterarSenha from "./pages/Login/AlterarSenha";
import AlterarSenhaEnviado from "./pages/Login/AlterarSenhaEnviado";
import PerfisListar from "./pages/Perfis/PerfisListar";
import PerfisIncluir from "./pages/Perfis/PerfisIncluir";
import PerfisAlterar from "./pages/Perfis/PerfisAlterar";
import MinhaContaAlterar from "./pages/Conta/MinhaContaAlterar";
import GrupoIncluir from "./pages/Grupos/GruposIncluir";
import GrupoListar from "./pages/Grupos/GruposListar";
import GruposAlterar from "./pages/Grupos/GruposAlterar";
import ColaboradoresListar from "./pages/Colaboradores/ColaboradoresListar";
import ColaboradoresIncluir from "./pages/Colaboradores/ColaboradoresIncluir";
import ColaboradoresAlterar from "./pages/Colaboradores/ColaboradoresAlterar";
import AcessoNaoPermitido from "./Components/Layout/AcessoNaoPermitido";
import ComputerRegistration from "./pages/Computadores/ComputerRegistration";
import Relatorios from "./Components/Relatorios/RelatoriosListar";
import RelatoriosImprimir from "./Components/Relatorios/RelatoriosImprimir";
import TermoAceite from "./pages/Termo/TermoAceite";
import MenuListar from "./pages/MenuBoot/MenuListar";
import MenuIncluir from "./pages/MenuBoot/MenuIncluir";
import MenuAlterar from "./pages/MenuBoot/MenuAlterar";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      //***********TERMO ACEITE DE USO**********
      {
        path: "/termo",
        element: <TermoAceite />,
      },
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/senha",
        element: <AlterarSenha />, // Rota protegida
      },
      {
        path: "/enviado",
        element: <AlterarSenhaEnviado />, // Rota protegida
      },
      //**********ACESSO AO MINHA CONTA NO HEADER**********
      {
        path: "/conta",
        element: <MinhaContaAlterar />,
      },
      {
        path: "/senha",
        element: <AlterarSenha />, // Rota protegida
      },
      {
        path: "/enviado",
        element: <AlterarSenhaEnviado />, // Rota protegida
      },
      {
        path: "/error",
        element: (
          <RequireAuth>
            <AcessoNaoPermitido />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/produtividade",
        element: (
          <RequireAuth>
            <UserMonitoring />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/home",
        element: (
          <RequireAuth>
            <DashboardGeral />
          </RequireAuth>
        ),
      },
      {
        path: "/image-gallery",
        element: (
          <RequireAuth>
            <ImageGallery />
          </RequireAuth>
        ),
      },

      //**********CONFIGURAÇÕES GERAIS**********
      {
        path: "/config",
        element: (
          <RequireAuth>
            <ConfiguracoesGerais />
          </RequireAuth>
        ),
      },
      //**********MENUBOOT**********
      {
        path: "/menu",
        element: (
          <RequireAuth>
            <MenuListar />
          </RequireAuth>
        ),
      },
      {
        path: "/menuboot/incluir",
        element: (
          <RequireAuth>
            <MenuIncluir />
          </RequireAuth>
        ),
      },
      {
        path: "/menuboot/alterar/:id",
        element: (
          <RequireAuth>
            <MenuAlterar />
          </RequireAuth>
        ),
      },

      //**********JORNADAS**********
      {
        path: "/jornadas",
        element: (
          <RequireAuth>
            <CalendarioList />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/jornada",
        element: (
          <RequireAuth>
            <CalendarioRegistration />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/jornada/:idCalendar",
        element: (
          <RequireAuth>
            <CalendarioUpdate />
          </RequireAuth>
        ), // Rota protegida
      },
      //**********COMPUTADORES**********
      {
        path: "/computador/:id",
        element: (
          <RequireAuth>
            <ComputerUpdate />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/computadores", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <ComputerList />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/computadores/incluir", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <ComputerRegistration />
          </RequireAuth>
        ), // Rota protegida
      },

      //**********PERFIL**********
      {
        path: "/perfis/incluir",
        element: (
          <RequireAuth>
            <PerfisIncluir />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/perfis/:id",
        element: (
          <RequireAuth>
            <PerfisAlterar />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/perfis/lista", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <PerfisListar />
          </RequireAuth>
        ), // Rota protegida
      },

      //**********GRUPOS**********
      {
        path: "/grupos",
        element: (
          <RequireAuth>
            <GrupoListar />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/grupos/incluir",
        element: (
          <RequireAuth>
            <GrupoIncluir />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/grupos/alterar/:id",
        element: (
          <RequireAuth>
            <GruposAlterar />
          </RequireAuth>
        ), // Rota protegida
      },

      //**********COLABORADORES**********
      {
        path: "/colaboradores",
        element: (
          <RequireAuth>
            <ColaboradoresListar />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/colaborador/incluir",
        element: (
          <RequireAuth>
            <ColaboradoresIncluir />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/colaborador/alterar/:id",
        element: (
          <RequireAuth>
            <ColaboradoresAlterar />
          </RequireAuth>
        ), // Rota protegida
      },

      //**********USER**********
      {
        path: "/user-dashboard/:id", // Rota de detalhes do usuário com ID
        element: (
          <RequireAuth>
            <UserDashboard />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/usuarios/registro", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <UserRegistration />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/usuarios", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <UsersList />
          </RequireAuth>
        ), // Rota protegida
      },
      {
        path: "/usuario/:id", // Corrigido para começar com "/"
        element: (
          <RequireAuth>
            <UserUpdate />
          </RequireAuth>
        ), // Rota protegida
      },
      //**********RELATORIOS**********
      {
        path: "/relatorios",
        element: (
          <RequireAuth>
            <Relatorios />
          </RequireAuth>
        ),
      },
      {
        path: "/relatorios/:id",
        element: (
          <RequireAuth>
            <RelatoriosImprimir />
          </RequireAuth>
        ),
      },
      // Redirecionamento
      {
        path: "*", // Redireciona qualquer caminho não encontrado para o login
        element: <Navigate to="/home" replace />,
      },
    ],
  },
]);

export default routes;
